/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferBatchesControllerDeleteBatchMutationResponse, TransferBatchesControllerDeleteBatchPathParams } from "../../models/transferBatchesController/TransferBatchesControllerDeleteBatch";

function getTransferBatchesControllerDeleteBatchUrl(id: TransferBatchesControllerDeleteBatchPathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/transfer-batches/${id}` as const }  
  return res
}

/**
 * @summary Delete a transfer batch
 * {@link /api/v1/transfer-batches/:id}
 */
export async function transferBatchesControllerDeleteBatch(id: TransferBatchesControllerDeleteBatchPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransferBatchesControllerDeleteBatchMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getTransferBatchesControllerDeleteBatchUrl(id).url.toString(), ... requestConfig })  
  return res.data
}